module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.areZonesValid),
      expression: "!areZonesValid"
    }]
  }, [_vm._v("Published forecasts need at least one zone")]), _vm._v(" "), (_vm.isShowSelectButtons) ? _c('div', [_c('ClientColorButton', {
    attrs: {
      "disabled": _vm.areAllSelected
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("Select all")]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "disabled": _vm.areAllUnSelected
    },
    on: {
      "click": _vm.unselectAll
    }
  }, [_vm._v("Select none")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, _vm._l((_vm.allBrandZone), function(brandZone) {
    return (brandZone.active || _vm.forecast.id) ? _c('div', {
      key: brandZone.id,
      staticClass: "option"
    }, [_c('div', [_c('div', {
      staticClass: "multiValidation",
      class: {
        hidden: !brandZone.zoneRelationType.multivalidation
      }
    }, [_c('MarketIcon')], 1)]), _vm._v(" "), _c('div', [_c('input', {
      attrs: {
        "disabled": _vm.isDisabled(brandZone.zone) || _vm.isDeleted(brandZone.zone),
        "id": ("zone_" + (brandZone.zone.id)),
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isZoneChecked(brandZone.zone),
        "value": brandZone.zone.id
      },
      on: {
        "change": function($event) {
          _vm.onZoneChange($event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', [_c('label', {
      class: {
        disabled: !_vm.hasUserAccessToZone(brandZone.zone) || _vm.disabled
      },
      attrs: {
        "for": ("zone_" + (brandZone.zone.id))
      }
    }, [_vm._v("\n                    " + _vm._s(brandZone.zone.name) + " "), (_vm.isDeleted(brandZone.zone)) ? _c('span', [_c('i', [_vm._v("(DELETED)")])]) : _vm._e()])])]) : _vm._e()
  })), _vm._v(" "), (_vm.isShowSelectButtons) ? _c('div', [_c('ClientColorButton', {
    attrs: {
      "disabled": _vm.areAllSelected
    },
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("Select all")]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "disabled": _vm.areAllUnSelected
    },
    on: {
      "click": _vm.unselectAll
    }
  }, [_vm._v("Select none")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58640988","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/form/ZoneSelection.vue
// module id = 3200
// module chunks = 0